exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table_error_message {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin: 10px 0;\n  padding: 16px;\n  border: 1px solid #ccc;\n  background-color: #eee;\n  -webkit-animation: FadeInAnimation 1s ease;\n  animation: FadeInAnimation 1s ease; }\n  .table_error_message span {\n    color: #ff0000;\n    font-weight: bold;\n    margin-left: auto;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/errorBoundary/tableErrorMessage/TableErrorMessage.style.scss
// module id = 1591
// module chunks = 0